@if(isTranscriptEnabled){
<div [ngStyle]="getDynamicPosition()"
     [ngClass]="{'override-transform': !isPlayerDetached}"
     [cdkDragFreeDragPosition]="dragPosition" cdkDrag>
    <div class="transcript">
        <div cdkDragHandle [ngClass]="{'--move': isPlayerDetached}">
            <span [ngStyle]="getConditionalStyles()" [class.highlighted]="true">
                <i (click)="onCloseClick()" class="clickable fa-light fa-close close-transcript-icon"></i>
                <span *ngFor="let segment of transcriptData; let i = index">
                    <span *ngIf="currentSegmentIndex == i">{{ segment.message }}</span>
                </span>
            </span>
        </div>
    </div>
</div>

}